import { gql } from "@apollo/client";
import { StaffOverrideConfig } from "src/components/Inputs/MultiSelectSchoolRank";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import * as GQL from "src/types/graphql";

export const GET_STAFF_SCHOOL_SELECTION_OVERRIDE = gql`
  query GetStaffSchoolSelectionOverride($form_template_id: uuid!) {
    form_template_by_pk(id: $form_template_id) {
      id
      allow_staff_school_selection_override
      staff_school_selection_override_config
    }
  }
`;

type OverrideConfigJson = {
  eligibleLabel?: string | null;
  ineligibleLabel?: string | null;
  reason?: {
    type?: "freeText" | "options";
    required?: boolean;
    options?: string[];
  } | null;
} | null;

// Reads the form template's staff-override toggle and config for the staff
// school-selection editor. Returns allowIneligible=false until loaded so the
// feature stays inert unless the template opts in.
export function useStaffOverrideConfig(formTemplateId: string): {
  allowIneligible: boolean;
  overrideConfig: StaffOverrideConfig;
} {
  const { remoteData } = useRemoteDataQuery<
    GQL.GetStaffSchoolSelectionOverride,
    GQL.GetStaffSchoolSelectionOverrideVariables
  >(GET_STAFF_SCHOOL_SELECTION_OVERRIDE, {
    variables: { form_template_id: formTemplateId },
  });

  const formTemplate = remoteData.toNullable()?.form_template_by_pk;
  const allowIneligible =
    formTemplate?.allow_staff_school_selection_override ?? false;
  const config = (formTemplate?.staff_school_selection_override_config ??
    null) as OverrideConfigJson;

  return {
    allowIneligible,
    overrideConfig: {
      eligibleLabel: config?.eligibleLabel || "Eligible",
      ineligibleLabel: config?.ineligibleLabel || "Ineligible",
      reason: {
        reasonType: config?.reason?.type ?? "freeText",
        reasonRequired: config?.reason?.required ?? false,
        reasonOptions: config?.reason?.options ?? [],
      },
    },
  };
}
